import { render, staticRenderFns } from "./ViewScore.vue?vue&type=template&id=62f8dd32"
import script from "./ViewScore.vue?vue&type=script&lang=js"
export * from "./ViewScore.vue?vue&type=script&lang=js"
import style0 from "./ViewScore.vue?vue&type=style&index=0&id=62f8dd32&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports